export const confirmList = [
  {
    id: 1,
    title: "提示",
    max_title: "确定下架该商品?",
    min_title: "",
    icon: "ios-information-circle",
    color: "#FF8400",
    cancelBtnShow: true,
  },
  {
    id: 2,
    title: "提示",
    max_title: "确定恢复上架?",
    min_title: "",
    icon: "ios-information-circle",
    color: "#FF8400",
    cancelBtnShow: true,
  },
  {
    id: 3,
    title: "提示",
    max_title: "确定屏蔽该商品?",
    min_title: "",
    icon: "ios-information-circle",
    color: "#FF8400",
    cancelBtnShow: true,
  },
  {
    id: 4,
    title: "提示",
    max_title: "确定取消商品屏蔽?",
    min_title: "",
    icon: "ios-information-circle",
    color: "#FF8400",
    cancelBtnShow: true,
  },
  {
    id: 5,
    title: "提示",
    max_title: "该商品正在还价中，确认要下架该商品吗?",
    min_title: "",
    icon: "ios-information-circle",
    color: "#FF8400",
    cancelBtnShow: true,
  },
];
